module.exports = __webpack_public_path__ + "static/media/networth3.d64e139e.png";